import { $WS } from "../webSocketProtoHead";
import { MSG } from "../../proto/proto";
import { SUB } from "../wsProtoConfigBase";

export interface MsgBody {
    frameTime: number;
    pUidList: string[],
    pSeatList: number[],
    pNameList: string[],
}

export default class SSubFpsGameStart implements $WS.WebSocketProtoHeadBody {
    //协议头
    static readonly HEAD: number = SUB.SSubFpsGameStart;
    //
    readonly head: number;
    body: MsgBody;

    constructor(frameTime: number, uidList: string[], seatList: number[], nameList: string[]) {
        this.head = SSubFpsGameStart.HEAD;
        this.body = {
            frameTime,
            pUidList: uidList,
            pSeatList: seatList,
            pNameList: nameList,
        };
    }

    getPackageBody(gameId: number): Uint8Array {
        let obj = $WS.getHallGameProtoHeadObject(this.head, $WS.ProtoHead.GAME, gameId);
        obj = Object.assign(obj, this.body);
        return MSG.SSubFpsGameStart.encode(obj).finish();
    }

    static unPackageMessage(message: Uint8Array): SSubFpsGameStart {
        const msg: any = MSG.SSubFpsGameStart.decode(message);
        const res = <MsgBody>msg;
        return new SSubFpsGameStart(
            res.frameTime, res.pUidList, res.pSeatList, res.pNameList);
    }
}